import useAthleteActions from "providers/AthletesProvider/useAthleteActions";
import useMutation from "hooks/useMutation";

export interface UseAthleteDeleteEmailMutationProps {
  /** Only part of the mutation key: the athlete the request acts on comes from the trigger argument. */
  athleteId?: string;
}

export interface AthleteDeleteEmailArg {
  athleteId: string;
  email?: string | null;
}

/**
 * @description Cancels the athlete's invitation by clearing their email address.
 * Goes through the athletes store so the athlete held there is updated alongside the request,
 * without an extra fetch.
 */
function useAthleteDeleteEmailMutation(props: UseAthleteDeleteEmailMutationProps) {
  const queryKey = ["AthleteService.cancelInvite", props.athleteId];
  const { cancelEmail } = useAthleteActions();

  return useMutation<void, Error, typeof queryKey, AthleteDeleteEmailArg>(queryKey, async (_, { arg }) =>
    cancelEmail(arg.athleteId, arg.email)
  );
}

export default useAthleteDeleteEmailMutation;
